import './CartProductPrice.scss'

import {toCents, toVisualPrice} from '../../../../util/price'

import {Price} from '../../ui/Price'
import React from 'react'
import {style} from '../../../../util/style'
import {useTranslation} from '../../../../util/i18n'

const styles = style('cartproductprice')

export const CartProductPrice: React.FC<{
	priceAfterDiscount: string
	price: string
	quantity: number
	totalProduct: number
	alignLeft?: boolean
}> = ({priceAfterDiscount, price, alignLeft, quantity}) => {
	const t = useTranslation('webshop').cart

	const fullPrice = toCents(price) * quantity
	const fullPriceAfterDiscount = toCents(priceAfterDiscount) * quantity

	const isFree = (!price || price === '0') && fullPriceAfterDiscount === 0

	const visualPrice = toVisualPrice(fullPrice)
	const visualPriceAfterDiscount = toVisualPrice(fullPriceAfterDiscount)

	return (
		<div className={styles.mod({alignleft: alignLeft})}>
			<div className={styles('placeholder')}>
				{priceAfterDiscount && fullPrice !== fullPriceAfterDiscount && (
					<Price discounted isFree={isFree}>
						{`€${visualPrice}`}
					</Price>
				)}
			</div>
			<div className={styles('discount')}>
				<Price>
					{isFree ? t.free : `€${visualPriceAfterDiscount || visualPrice}`}
				</Price>
			</div>
		</div>
	)
}
